import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams, ISimpleFilter } from 'ag-grid-community';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import * as CONSTANT from 'src/app/shared/constants/constant-list';

export interface CustomParams {
  suppressFilterButton: boolean;
  filter: string;
  onSearchEvent: (event: any) => void;
}

@Component({
  selector: 'app-lrc-statuses-renderer',
  templateUrl: './lrc-statuses-renderer.component.html',
  styleUrls: ['./lrc-statuses-renderer.component.scss'],
})
export class LrcStatusesRendererComponent
  implements IFloatingFilterAngularComp
{
  @Output() onFilterSearchText: EventEmitter<any> = new EventEmitter<any>();

  filterSearchText = new Subject<any>();
  filterText: string | null = null;

  params!: IFloatingFilterParams<ISimpleFilter> & CustomParams;
  IFloatingParams: IFloatingFilterParams | any;

  COMPLIANCE_VERIFICATION_STATUS: any = CONSTANT.CASHOUT_TRANSACTION_STATUS;

  filterOptions: any[] = [];
  currentValue: any;
  value: any;

  constructor() {}

  agInit(params: IFloatingFilterParams<ISimpleFilter> & CustomParams) {
    this.filterOptions = [
      {
        value: this.COMPLIANCE_VERIFICATION_STATUS.PENDING,
        name: 'PENDING',
      },
      {
        value: this.COMPLIANCE_VERIFICATION_STATUS.RETURNED,
        name: 'RETURNED',
      },
      {
        value: this.COMPLIANCE_VERIFICATION_STATUS.COMPLETED,
        name: 'COMPLETED',
      },
    ];
    this.filterText = null;
    this.params = params;

    this.filterSearchText
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe({
        next: (event: any) => {
          this.params?.onSearchEvent({
            value: event?.target?.value,
            filter: params?.filter,
          });
        },
      });
  }

  onParentModelChanged(parentModel: any) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
      this.filterOptions = [];
    } else {
      this.currentValue = parentModel.filter;
    }
  }
}
